export const RESET = 'CLIENTTYPE_LIST_RESET'
export const SET_ITEMS = 'CLIENTTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'CLIENTTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'CLIENTTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CLIENTTYPE_LIST_TOGGLE_LOADING'
export const SET_TOTAL_ITEMS = 'CLIENTTYPE_LIST_SET_TOTAL_ITEMS'
